var React = require('react');

function Slider (props) {
    return React.createElement("svg",props,React.createElement("switch",null,React.createElement("g",null,React.createElement("path",{"d":"M0 0h5.3v62.3H0zM40 0h5.3v62.3H40zM14 0h4.5v62.3H14zM27 0h4.5v62.3H27z"}))));
}

Slider.defaultProps = {"viewBox":"0 0 45.4 62.4"};

module.exports = Slider;

Slider.default = Slider;
